import swal from "sweetalert";
import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { activarPersona } from "../../services/personas-service";

const PersonasInactivas = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    if (userCan("personasAdministrarPermisos")) {
        tableButtons.push({
            titleAttr: "Activar personas",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-secondary",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta persona?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Activar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado la persona");
                        break;
                    case "activar": {
                        const resp = await activarPersona(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la persona"
                            );
                        }
                        sweetAl.success("La persona fue activada");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "Personas-inactivas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaInactivas",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/personas/inactivas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listdo de las personas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "info_documento" },
            { data: "info_persona" },
            { data: "fecha_nace" },
            { data: "area" },
            { data: "usuario" },
            { data: "email_persona" },
            { data: "estado_persona" },
        ],
        columnDefs: [
            {
                targets: [7],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 0 ? "Inactivo" : "Activo";
                    td.classList.add(
                        cellData == 0 ? "text-warning" : "text-success"
                    );
                    td.classList.add("text-bold");
                },
            },
        ]
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    USUARIOS / Inactivos
                </div>
            </div>
            <Datatable options={dtOptions}>
                <table className="w-100 table table-hover" id="tablaInactivas">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Documento</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">Fecha de nacimiento</th>
                            <th className="text-center text-white">Area</th>
                            <th className="text-center text-white">Usuario</th>
                            <th className="text-center text-white">Correo</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default PersonasInactivas;
